import { reaction } from 'mobx';
import { IReactionDisposer } from 'mobx/lib/internal';
import { SnapLineElement } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/edit-pc/edit-layer/element/snap-line-element';
import RegionRenderService from '@src/slide/content-viewer/service/canvas-renderer/entry/base/performance/base-region-render-service';
import SnaplineManager from '@editor/src/page/index/components/canvas/snapline-manager';

/**
 * 对齐线渲染层，目前仅在移动端应用
 */
export default class SnapLineRenderService extends RegionRenderService {
    private snapLineComponent: SnapLineElement;
    private reaction: IReactionDisposer | null;
    public constructor(props) {
        super(props);
    }

    public init(): void {
        if (!this.reaction) {
            this.reaction = reaction(
                () => SnaplineManager.getInstance().getActiveSnapLines(),
                (activeSnapLines) => {
                    this.buildSnapLineOuter(activeSnapLines);
                },
            );
        }
    }

    public dispose(): void {
        this.reaction?.();
        this.reaction = null;
    }

    private buildSnapLineOuter(lines = []) {
        this.snapLineComponent?.dispose();
        this.renderArea?.clearAllComponent();
        if (lines?.length) {
            this.snapLineComponent = new SnapLineElement(lines, this.scale);
            this.renderArea.updateComponents(this.snapLineComponent);
        }
    }
}
